<template>
    <nav>
        <router-link to="/">
            {{ mainBudget.when }} {{ mainBudget.type }} Budget
        </router-link>
        <label for="dept-select" class="sr-only">Select a Department</label>
        <SelectDepartment :departments="departments" id="dept-select" />
    </nav>
</template>

<script>
    import SelectDepartment from '@/components/SelectDepartment';

    export default {
        name:'Nav',
        props: {
            'mainBudget' : Object,
            'departments' : Array
        },
        components:{
            SelectDepartment
        }
    }
</script>

<style>
    nav:after {
        content:'';
        display:block;
        width:100%;
        clear:both;
    }
</style>
